import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';

const WorkforceManagement = lazy(() => import('../pages/hr/WorkforceManagement'));

export const hrRoutes = (
  <>
    <Route
      path="/workforce-management"
      element={
        <ProtectedRoute module={['attendance', 'leave', 'expenses']} action="view">
          <WorkforceManagement />
        </ProtectedRoute>
      }
    />
    {/* Legacy redirects for bookmarks and direct links */}
    <Route path="/attendance" element={<Navigate to="/workforce-management?tab=attendance" replace />} />
    <Route path="/leave" element={<Navigate to="/workforce-management?tab=leave" replace />} />
    <Route path="/expenses" element={<Navigate to="/workforce-management?tab=expenses" replace />} />
  </>
);

export default hrRoutes;
